import { LocalizedTextProps } from '@mews/framework';
import { LocalizedSmallParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { NoItemsContainer } from './styles';

const NoItems = ({
    textKey = TextKey.NoItems,
    substitutes,
}: Partial<Pick<LocalizedTextProps, 'textKey' | 'substitutes'>>) => (
    <NoItemsContainer>
        <LocalizedSmallParagraph textKey={textKey} substitutes={substitutes} />
    </NoItemsContainer>
);

export default NoItems;
